(() => {
  angular
    .module('gm.common.conversion')
    .directive('gmyConvertFromGold', gmyConvertFromGold);

  function gmyConvertFromGold(
    $filter,
    GmyCurrencies
  ) {
    'ngInject';

    return {
      replace: true,
      restrict: 'E',
      scope: {
        format: '=?'
      },
      templateUrl: 'modules/conversion/directives/convert-from-gold/convert-from-gold.html',
      link(scope, _element, attrs) {
        function formatAmount(origAmount, currency) {
          let amount = $filter('gmyConvertFromGold')(origAmount, currency.code);
          if (scope.format) {
            amount = $filter('gmyFormatCurrency')(amount, currency.code);
          }
          return amount;
        }

        const amount = attrs.amount || 0;

        scope.format = scope.format || true;

        const currency = GmyCurrencies.getTempLivePriceCurrency();
        scope.amount = formatAmount(amount, currency);

        const deregisterCurrencyListener = scope.$on('gm:currency:changed',
        (_event, newCurrency) => {
          scope.amount = formatAmount(amount, newCurrency);
        });

        scope.$on('$destroy', () => {
          deregisterCurrencyListener();
        });
      }
    };
  }
})();
